import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/auth/signup/page.tsx");
